"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPrice = void 0;
const round_1 = __importDefault(require("lodash/round"));
function formatPrice({ price, currency, roundingPrecision, shouldRound, country }) {
    let precision = 2;
    if (roundingPrecision) {
        if (price > 20) {
            precision = 0;
        }
        else if (price > 10) {
            precision = 1;
        }
    }
    let finalPrice = price;
    if (!shouldRound) {
        precision = 2;
        // Only take two digits after the decimal point, otherwise Intl.NumberFormat will round it
        finalPrice = price.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
    }
    // If price is in USD and country is not US
    if (currency === 'USD') {
        const symbol = country === 'US' ? '$' : 'US$';
        return symbol + (shouldRound ? (0, round_1.default)(price, precision) : finalPrice);
    }
    return new Intl.NumberFormat([], {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: precision,
        minimumFractionDigits: 0
    }).format(finalPrice);
}
exports.formatPrice = formatPrice;
//# sourceMappingURL=formatPrice.js.map